/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:48 PM
 *
 */

import ProfileTestExport from 'features/members/components/others/ProfileTestExport/ProfileTestExport';

export default ProfileTestExport;
